import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from "react-router";
import ALoader from 'views/pages/manage/common/a-loader';
import ViewCashReceiptDetail from './ViewCashReceiptDetail';
import ProgressAndActionsWrapper from './ProgressAndActionsWrapper';
import { getCashDepositDetails, getDropdowns } from './utils';
import CashDepositHeader from './CashDepositHeader';
import { useFetchBankAccount } from '../../cash-management/hooks/useFetchBankAccount';
import { useApprovalListing } from '../../approvalDashboard/shared/hooks'
import { PermissionContext } from 'appContext';
import DocumentViewer from "../../cash-management/receipt/components/DocumentViewerModal";
import ConfirmRejectionDialog from 'views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ConfirmRejectionDialog';
import ApprovalSentSuccessDialog from 'views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';


const ViewCashDepositApproval = () => {

    const [details, setDetails] = useState({});
    const [loading, setLoading] = useState(false)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const depositSlipNo = queryParams.get('depositSlipNo');
    const isBmApproval = queryParams.get('isBmApproval');
    const businessAreaValue = queryParams.get('businessAreaValue');
    const cashReceiptId = queryParams.get("cashReceiptId");
    const [paginationInfo, setPaginationInfo] = useState({
        currPageNo: 0,
        currPageSize: 10,
        totalRecords: 0
    });
    const permissions = useContext(PermissionContext);

    const getDetails = async () => {
        try {
            setLoading(true);
            const reqObj = {
                depositSlipId: Number(cashReceiptId)
            }
            const resp = await getCashDepositDetails({ pageNo: 0, pageSize: 10, setPaginationInfo, reqObj });
            setDetails(resp);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }

    const { bankDetails } = useFetchBankAccount(businessAreaValue);

    const init = async () => {
        getDetails();
    }
    useEffect(() => {
        init();
    }, [])

    const {
        dropdownData,
        approvalRequests,
        approvalActionSuccessDialogInfo,
        setApprovalActionSuccessDialogInfo,
        updateStatusInfo,
        setUpdateStatusInfo,
        onViewSlip,
        viewer,
        setViewer,
        updateStatus,
        getApprovalRequests

    } = useApprovalListing({ isFirstTimeApiCallRequred: false, permissions, filters: { depositSlipNo }, setLoading });

    const progressActionProps = {
        dropdowns: dropdownData,
        depositSlipNo,
        getDetails,
        details,
        setLoading,
        updateStatus,
        updateStatusInfo,
        setUpdateStatusInfo,
        isBmApproval,
        approvalActionSuccessDialogInfo,
        setApprovalActionSuccessDialogInfo,
        approvalRequests:
            approvalRequests && approvalRequests.length > 0
                ? approvalRequests[0]
                : [],
        depositSlipId: Number(cashReceiptId),
        businessAreaValue
        
    };

    const viewCashReceiptProps = {
        dropdowns: dropdownData,
        details,
        setDetails,
        logs: details?.logs,
        loading,
        setLoading,
        paginationInfo,
        setPaginationInfo,
        onViewSlip,
        cashReceiptId,
    }

    return (
        <>
            {loading && <ALoader position='fixed' />}
            <CashDepositHeader
                referenceNo={depositSlipNo}
                details={{
                    type: "Owned branch",
                    bankName: bankDetails?.description,
                    accountNo: bankDetails?.bankAccount
                }}
            />

            <div className="mx-5 d-flex justify-space-between">
                <div style={{ width: "65%" }}>
                    <ViewCashReceiptDetail data={viewCashReceiptProps} />
                </div>
                <div className="flex-grow-1">
                    <ProgressAndActionsWrapper data={progressActionProps}/>
                </div>
            </div>

            <DocumentViewer
                open={viewer.open}
                onClose={() => setViewer({ open: false, s3key: "" })}
                s3Key={viewer.s3key}
            />

            <ApprovalSentSuccessDialog
                open={approvalActionSuccessDialogInfo}
                setOpen={setApprovalActionSuccessDialogInfo}
                heading={approvalActionSuccessDialogInfo?.heading}
                subHeading={approvalActionSuccessDialogInfo?.subHeading}
                closeCb={() => {
                    getDetails();
                    getApprovalRequests({ filters: { depositSlipNo } });
                }}
            />

            <ConfirmRejectionDialog
                updateStatusInfo={updateStatusInfo}
                setUpdateStatusInfo={setUpdateStatusInfo}
                updateStatus={updateStatus}
                dialogInfo={updateStatusInfo?.dialogInfo}
                customStyle={{ maxWidth: '424px' }}
            />
        </>
    )
}

export default ViewCashDepositApproval;